import { useContext } from "react";
import { SnackbarContext } from "../contexts/SnackbarContextProvider";
import { SnackbarInterface } from "../contexts/Snackbar";

export const useSnackbar = () => {
  const { showSnackbar } = useContext<SnackbarInterface>(SnackbarContext);
  return { showSnackbar };
};
